import { fromString } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { bool_type, array_type, record_type, int32_type, string_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";

export function tryGetRememberMe() {
    try {
        let _arg;
        const value = localStorage.getItem("ikt-skip-remember-me");
        _arg = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(string_type, undefined, undefined)), value);
        return (_arg.tag === 0) ? _arg.fields[0] : undefined;
    }
    catch (matchValue) {
        return undefined;
    }
}

export function storeRememberMe(username) {
    try {
        const x = toString(4, Auto_generateBoxedEncoder_437914C6(string_type, undefined, undefined, undefined)(username));
        localStorage.setItem("ikt-skip-remember-me", x);
    }
    catch (matchValue) {
    }
}

export function deleteRememberMe() {
    try {
        localStorage.removeItem("ikt-skip-remember-me");
    }
    catch (matchValue) {
    }
}

export class VesselListPreferences extends Record {
    constructor(Presentation) {
        super();
        this.Presentation = (Presentation | 0);
    }
}

export function VesselListPreferences_$reflection() {
    return record_type("LocalStorage.VesselListPreferences", [], VesselListPreferences, () => [["Presentation", int32_type]]);
}

export function tryGetVesselListPreferences() {
    try {
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(VesselListPreferences_$reflection(), undefined, undefined)), localStorage.getItem("vessel-list-pref"));
        return (matchValue.tag === 0) ? matchValue.fields[0] : undefined;
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export function setVesselListPreferences(x) {
    try {
        const content = toString(2, Auto_generateBoxedEncoder_437914C6(VesselListPreferences_$reflection(), undefined, undefined, undefined)(x));
        localStorage.setItem("vessel-list-pref", content);
    }
    catch (matchValue) {
    }
}

export class RouteListPreferences extends Record {
    constructor(Presentation) {
        super();
        this.Presentation = (Presentation | 0);
    }
}

export function RouteListPreferences_$reflection() {
    return record_type("LocalStorage.RouteListPreferences", [], RouteListPreferences, () => [["Presentation", int32_type]]);
}

export function tryGetRouteListPreferences() {
    try {
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(RouteListPreferences_$reflection(), undefined, undefined)), localStorage.getItem("route-list-pref"));
        return (matchValue.tag === 0) ? matchValue.fields[0] : undefined;
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export function setRouteListPreferences(x) {
    try {
        const content = toString(2, Auto_generateBoxedEncoder_437914C6(RouteListPreferences_$reflection(), undefined, undefined, undefined)(x));
        localStorage.setItem("route-list-pref", content);
    }
    catch (matchValue) {
    }
}

export class ListFilter extends Record {
    constructor(Companies, Status, Favorites, Date$) {
        super();
        this.Companies = Companies;
        this.Status = Status;
        this.Favorites = Favorites;
        this.Date = Date$;
    }
}

export function ListFilter_$reflection() {
    return record_type("LocalStorage.ListFilter", [], ListFilter, () => [["Companies", array_type(int32_type)], ["Status", array_type(int32_type)], ["Favorites", bool_type], ["Date", string_type]]);
}

export function tryGetVesselListFilter() {
    try {
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(ListFilter_$reflection(), undefined, undefined)), localStorage.getItem("vessel-list-filter"));
        return (matchValue.tag === 0) ? matchValue.fields[0] : undefined;
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export function setVesselListFilter(x) {
    try {
        const content = toString(2, Auto_generateBoxedEncoder_437914C6(ListFilter_$reflection(), undefined, undefined, undefined)(x));
        localStorage.setItem("vessel-list-filter", content);
    }
    catch (matchValue) {
    }
}

export function deleteVesselListFilter() {
    try {
        localStorage.removeItem("vessel-list-filter");
    }
    catch (matchValue) {
    }
}

export function tryGetRouteListFilter() {
    try {
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(ListFilter_$reflection(), undefined, undefined)), localStorage.getItem("route-list-filter"));
        return (matchValue.tag === 0) ? matchValue.fields[0] : undefined;
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export function setRouteListFilter(x) {
    try {
        const content = toString(2, Auto_generateBoxedEncoder_437914C6(ListFilter_$reflection(), undefined, undefined, undefined)(x));
        localStorage.setItem("route-list-filter", content);
    }
    catch (matchValue) {
    }
}

export function deleteRouteListFilter() {
    try {
        localStorage.removeItem("route-list-filter");
    }
    catch (matchValue) {
    }
}

export class TimelineFilter extends Record {
    constructor(Favorites, MyCompanies) {
        super();
        this.Favorites = Favorites;
        this.MyCompanies = MyCompanies;
    }
}

export function TimelineFilter_$reflection() {
    return record_type("LocalStorage.TimelineFilter", [], TimelineFilter, () => [["Favorites", bool_type], ["MyCompanies", bool_type]]);
}

export function tryGetTimelineFilter() {
    try {
        const matchValue = fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(TimelineFilter_$reflection(), undefined, undefined)), localStorage.getItem("timeline-filter"));
        return (matchValue.tag === 0) ? matchValue.fields[0] : undefined;
    }
    catch (matchValue_1) {
        return undefined;
    }
}

export function setTimelineFilter(x) {
    try {
        const content = toString(2, Auto_generateBoxedEncoder_437914C6(TimelineFilter_$reflection(), undefined, undefined, undefined)(x));
        localStorage.setItem("timeline-filter", content);
    }
    catch (matchValue) {
    }
}

//# sourceMappingURL=LocalStorage.js.map
